export const UNAUTHENTICATED = 'unauthenticated';
